import { Injectable } from '@angular/core';
import { DisplayStageNatureTypeDto } from '../../beneficiaries/beneficiary-folder/stages/display-stage-nature-type.dto';
import { CommunityActionDto } from '../../community-action/dto/communityAction.dto';
import { environment } from '../../environments/environment';
import { CommunityActionFilter } from '../filter/communityActionFilter';
import { DisplayCommunityAction } from '../models/displayCommunityAction';
import { DisplayLabel } from '../models/displayLabel';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CommunityActionService {
  constructor(private readonly api: ApiService) {}

  public async findNaturesByProfile(): Promise<DisplayStageNatureTypeDto[]> {
    return this.api.get<DisplayStageNatureTypeDto[]>(environment.api.communityAction + '/naturesByProfile');
  }

  public async findNatures(): Promise<DisplayStageNatureTypeDto[]> {
    return this.api.get<DisplayStageNatureTypeDto[]>(environment.api.communityAction + '/natures');
  }

  public async saveCommunityAction(communityAction: CommunityActionDto): Promise<number> {
    return this.api.post<number, CommunityActionDto>(environment.api.communityAction, communityAction);
  }

  public async findById(id: number): Promise<CommunityActionDto> {
    return this.api.get<CommunityActionDto>(environment.api.communityAction + '/' + id + '/details');
  }

  public async terminate(id: number): Promise<void> {
    return this.api.get<void>(environment.api.communityAction + '/' + id + '/terminate');
  }

  public async delete(id: number): Promise<void> {
    return this.api.delete<void>(environment.api.communityAction + '/' + id);
  }

  public async reactivate(id: number): Promise<void> {
    return this.api.get<void>(environment.api.communityAction + '/' + id + '/reactivate');
  }

  public async findActionsLabelStage(natureTypeId: number): Promise<DisplayCommunityAction[]> {
    return this.api.get<DisplayCommunityAction[]>(environment.api.communityAction + '/' + natureTypeId + '/actionsLabelStage');
  }

  public async findActionsLabelFse(structureId: number, year: string): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.communityAction + '/' + structureId + '/' + year + '/actionsLabelFse');
  }

  public async findStructureIdByAction(actionId: number): Promise<number> {
    return this.api.get<number>(environment.api.communityAction + '/' + actionId + '/structureIdByAction');
  }

  public async findSessionLabelById(sessionId: number): Promise<DisplayLabel> {
    return this.api.get<DisplayLabel>(environment.api.communityAction + '/' + sessionId + '/sessionLabelById');
  }

  public async findActionsLabelStageById(actionId: number): Promise<DisplayCommunityAction> {
    return this.api.get<DisplayCommunityAction>(environment.api.communityAction + '/' + actionId + '/actionLabelById');
  }

  public async findByFilter(communityActionFilter: CommunityActionFilter, options: PaginationOptions): Promise<Pagination<DisplayCommunityAction>> {
    return this.api.postPaginated<DisplayCommunityAction>(
      options.buildUrl(environment.api.communityAction + '/communityActions'),
      communityActionFilter,
    );
  }
}
